import { autoinject } from 'aurelia-framework';
import { SearchResult } from 'elements/search/search-input';
import { AsyncErrorHandler } from 'lib/ui';
import { I18N } from 'aurelia-i18n';
import { MooringArticleProductService } from 'services';
import { MooringArticleProduct } from 'models/mooring';

export type OnSelected<T> = {
  result: SearchResult<MooringArticleProduct>;
  item?: T;
};

export type MooringComponentSearchResult = SearchResult<MooringArticleProduct>;

type GetArticleProductDetails = {
  index: number;
  id: number;
  item: { Id: number; ProductName: string };
};

@autoinject
export class MooringComponentSearchHandler {
  /**
   *
   */
  constructor(
    private productService: MooringArticleProductService,
    private t: I18N
  ) {}

  cache = new Map<number, MooringArticleProduct>();

  public async preCache() {
    const articleProducts = await this.productService.items();

    for (const articleProduct of articleProducts ?? []) {
      this.cache.set(articleProduct.Id, articleProduct);
    }
  }

  @AsyncErrorHandler
  public async searchForArticleNumber(term: string) {
    const { data: result } = await this.productService.search(term);
    if (!result || !result.length) return [];

    return result.map((item) => {
      const { Id, ProductName, ArticleNumber, Category, Type, ProductType, MBL, SupplierName } = item;
      this.cache.set(Id, item);

      return {
        id: Id,
        title: `${ProductName} (${ArticleNumber})`,
        extra: [
          `${Category} / ${Type ?? ''} / ${ProductType ?? '-'}`,
          `${this.t.tr(`general.mbl`)}: ${MBL ?? '-'}`,
          `${this.t.tr(`general.supplier`)}: ${SupplierName}`,
        ],
        return: item,
      };
    });
  }

  // public async getArticleNumberDetails(o: GetArticleDetails) {
  @AsyncErrorHandler
  public async getDetails(o: GetArticleProductDetails) {
    console.log('get details for', o);
    const { item, id } = o;

    const result = {
      id,
      title: '',
    };

    if (item?.ProductName) {
      result.title = item.ProductName;
      return result;
    }

    const cached = this.cache.get(id);
    if (cached) {
      console.log('got details from cache', cached);
      result.title = cached.ProductName;
      return result;
    }

    console.log('getting from remote');
    const { data } = await this.productService.details(id);
    console.log('got details', data);
    if (data) {
      this.cache.set(id, data);
    }

    if (data) {
      result.title = data.ProductName;
    }

    return result;
  }
}
